import { useEffect, useState } from "react";
import api from "@/lib/api";
import Header from "@/components/Header";
import { Input } from "@/components/ui/input";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { Building2, ShoppingCart, Globe2, Truck } from "lucide-react";

export default function Integrations() {
  const [data, setData] = useState({ banks: [], carts: [], marketplaces: [], shipping: [], totals: {} });
  const [q, setQ] = useState("");

  useEffect(() => {
    api.get("/integrations").then((r) => setData(r.data)).catch(() => {});
  }, []);

  const filt = (arr) => arr.filter((x) => x.toLowerCase().includes(q.toLowerCase()));

  return (
    <div className="min-h-screen bg-[#F8FAFC] text-slate-900" data-testid="integrations-page">
      <Header />
      <section className="pt-32 pb-16">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <p className="text-xs uppercase tracking-[0.18em] text-[#00D533] mb-3">Integration Directory</p>
          <h1 className="font-heading text-4xl sm:text-5xl font-semibold tracking-tight" data-testid="integrations-title">
            The full SelleCheck stack.
          </h1>
          <p className="mt-4 max-w-2xl text-slate-500">
            Browse our connected banks, carts, marketplaces and shipping partners. Search to confirm
            yours is supported.
          </p>

          <div className="mt-8 max-w-md">
            <Input
              placeholder="Search integrations..."
              value={q}
              onChange={(e) => setQ(e.target.value)}
              className="bg-[#FFFFFF] border-slate-200 h-11"
              data-testid="integrations-search"
            />
          </div>

          <Tabs defaultValue="banks" className="mt-10">
            <TabsList className="bg-[#FFFFFF] border border-slate-200 p-1">
              <TabsTrigger value="banks" className="data-[state=active]:bg-slate-100" data-testid="tab-banks">
                <Building2 className="w-4 h-4 mr-2" /> Banks ({data.totals.banks || 0})
              </TabsTrigger>
              <TabsTrigger value="carts" className="data-[state=active]:bg-slate-100" data-testid="tab-carts">
                <ShoppingCart className="w-4 h-4 mr-2" /> Carts ({data.totals.carts || 0})
              </TabsTrigger>
              <TabsTrigger value="marketplaces" className="data-[state=active]:bg-slate-100" data-testid="tab-marketplaces">
                <Globe2 className="w-4 h-4 mr-2" /> Marketplaces ({data.totals.marketplaces || 0})
              </TabsTrigger>
              <TabsTrigger value="shipping" className="data-[state=active]:bg-slate-100" data-testid="tab-shipping">
                <Truck className="w-4 h-4 mr-2" /> Shipping ({data.totals.shipping || 0})
              </TabsTrigger>
            </TabsList>

            <TabsContent value="banks"><Grid items={filt(data.banks)} /></TabsContent>
            <TabsContent value="carts"><Grid items={filt(data.carts)} /></TabsContent>
            <TabsContent value="marketplaces"><Grid items={filt(data.marketplaces)} /></TabsContent>
            <TabsContent value="shipping"><Grid items={filt(data.shipping)} /></TabsContent>
          </Tabs>
        </div>
      </section>
    </div>
  );
}

function Grid({ items }) {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 mt-8" data-testid="integrations-grid">
      {items.map((name) => (
        <div key={name} className="sk-card px-4 py-3 text-sm text-slate-700 truncate">
          {name}
        </div>
      ))}
      {items.length === 0 && (
        <div className="col-span-full text-slate-400 text-sm py-12 text-center">No matches</div>
      )}
    </div>
  );
}
